import { useTranslation } from 'react-i18next';

function Services() {
  const { t } = useTranslation();
  const services = t('services.cards', { returnObjects: true });

  return (
    <section id="services" className="section services-section">
      <div className="section-heading">
        <div className="eyebrow">{t('services.eyebrow')}</div>
        <h2>{t('services.title')}</h2>
        <p>{t('services.description')}</p>
      </div>

      <div className="cards-grid services-grid">
        {services.map((service) => (
          <article className="service-card" key={service.number}>
            <div className="card-icon">{service.number}</div>
            <h3>{service.title}</h3>
            <p>{service.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default Services;
